import { ArrowRight, BookOpenText, GameController, PencilSimple } from '@phosphor-icons/react';
import RedesignImage from '../../shared/components/RedesignImage';
import { homepageImages } from '../assets';
import { useHomePageSharedStyles } from '../HomePage.styles';
import { UseHomePageReturn } from '../hooks/useHomePage';
import locale from '../locale.json';
import { useHomePageHeroStyles } from './HomePageHero.styles';

type HomePageHeroProps = {
  state: Pick<
    UseHomePageReturn,
    'user' | 'redirect' | 'isRattached' | 'heroStats' | 'serviceName'
  >;
};

const HomePageHero = ({ state }: HomePageHeroProps) => {
  const classes = useHomePageHeroStyles();
  const shared = useHomePageSharedStyles();
  const { user, redirect, isRattached, heroStats, serviceName } = state;

  return (
    <section className={classes.heroSection}>
      <div className={classes.heroImageWrap}>
        <RedesignImage
          priority={true}
          src={homepageImages.hero}
          alt="Illustration d'accueil"
          className={shared.cardImage}
        />
      </div>

      <div className={classes.heroContent}>
        <div className={classes.heroTextBlock}>
          <p className={isRattached ? classes.heroGreetingRattached : classes.heroGreeting}>
            {locale.greeting}{' '}
            <strong className={classes.heroGreetingName}>{user?.firstname || ''}</strong>,
          </p>
          <h1 className={classes.heroTitle}>{locale.heroTitle}</h1>
          <p className={classes.heroDescription}>{locale.heroDescription}</p>
        </div>

        {isRattached ? (
          <>
            <div className={classes.parcoursBar}>
              <p className={classes.parcoursTitle}>
                {serviceName || locale.rattachedServiceFallback}
              </p>
              <button type="button" className={classes.pillButton} onClick={() => redirect(3)}>
                {locale.continueJourneyCta}
                <ArrowRight className={classes.pillButtonIcon} aria-hidden="true" />
              </button>
            </div>

            <div className={classes.heroStatsRow}>
              <div className={classes.heroStatCard}>
                <div className={shared.itemIconWrap}>
                  <PencilSimple className={shared.itemIcon} aria-hidden="true" />
                </div>
                <div className={shared.itemTextBlock}>
                  <p className={shared.itemTitle}>{heroStats.completedTests}</p>
                  <p className={shared.itemDescription}>{locale.statCompletedTests}</p>
                </div>
              </div>

              <div className={classes.heroStatCard}>
                <div className={shared.itemIconWrap}>
                  <GameController className={shared.itemIcon} aria-hidden="true" />
                </div>
                <div className={shared.itemTextBlock}>
                  <p className={shared.itemTitle}>{heroStats.completedGames}</p>
                  <p className={shared.itemDescription}>{locale.statCompletedGames}</p>
                </div>
              </div>

              <div className={classes.heroStatCard}>
                <div className={shared.itemIconWrap}>
                  <BookOpenText className={shared.itemIcon} aria-hidden="true" />
                </div>
                <div className={shared.itemTextBlock}>
                  <p className={shared.itemTitle}>{heroStats.readEbooks}</p>
                  <p className={shared.itemDescription}>{locale.statReadEbooks}</p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className={classes.actionCards}>
            <div className={classes.actionCard}>
              <div className={classes.actionCardContent}>
                <div className={shared.itemIconWrap}>
                  <PencilSimple className={shared.itemIcon} aria-hidden="true" />
                </div>
                <div className={shared.itemTextBlock}>
                  <p className={shared.itemTitle}>{locale.testsCardTitle}</p>
                  <p className={shared.itemDescription}>{locale.testsCardDescription}</p>
                </div>
              </div>
              <button
                type="button"
                className={`${classes.primaryButton} ${classes.actionCardButton}`}
                onClick={() => redirect(1)}
              >
                {locale.testsCardCta}
              </button>
            </div>

            <div className={classes.actionCard}>
              <div className={classes.actionCardContent}>
                <div className={shared.itemIconWrap}>
                  <BookOpenText className={shared.itemIcon} aria-hidden="true" />
                </div>
                <div className={shared.itemTextBlock}>
                  <p className={shared.itemTitle}>{locale.resourcesCardTitle}</p>
                  <p className={shared.itemDescription}>{locale.resourcesCardDescription}</p>
                </div>
              </div>
              <button
                type="button"
                className={`${classes.secondaryButton} ${classes.actionCardButton}`}
                onClick={() => redirect(3)}
              >
                {locale.resourcesCardCta}
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomePageHero;
